export default {
  data () {
    return {
      popupArr: [],
      infoPopUp: ''
    }
  },
  methods: {
    doSearchCond (popupList) {
      this.popupArr = popupList
      if (this.popupArr && this.popupArr.length > 0) {
        for (let index = 0, len = this.popupArr.length; index < len; index++) {
          this.showWarnPopUp(this.popupArr[index], index)
        }
      }
    },
    showWarnPopUp (element, index) {
      this.infoPopUp = this.$info({
        class: 'common-popup',
        title: element.title || '温馨提示',
        width: 600,
        content: (h) => h('div', {
          domProps: {
            innerHTML: element.content
          }
        }),
        mask: index === 0,
        okText: '确认',
        onOk: () => {
          this.infoPopUp.destroy()
        }
      })
    }
  }
}
